import memoize from 'memoize-one';
import { UserName } from 'features/users/types';

const ALPHANUMERIC = /[\p{L}\p{N}]/u;

const firstAlphanumeric = (word: string) => [...word].find((char) => ALPHANUMERIC.test(char));

const firstCharacter = (word: string) => [...word][0];

const pickInitials = (words: string[], pick: (word: string) => string | undefined) => {
  const first = pick(words[0]) ?? '';

  if (words.length === 1) {
    return first;
  }

  return first + (pick(words[words.length - 1]) ?? '');
};

export const getInitials = memoize((name: UserName) => {
  if (!name) {
    return undefined;
  }

  const words = name.trim().split(/\s+/).filter(Boolean);

  if (words.length === 0) {
    return undefined;
  }

  const named = words.filter((word) => firstAlphanumeric(word));

  // a name of pure punctuation still gets a badge rather than an empty circle
  return named.length > 0
    ? pickInitials(named, firstAlphanumeric)
    : pickInitials(words, firstCharacter);
});
